export const PLAYER_MESSAGE_FUNCTION_NOTIFICATION_NEARBY = 'NOTIFICATION_NEARBY';
export const PLAYER_MESSAGE_FUNCTION_ACCOUNT_REGISTRATION = 'ACCOUNT_REGISTRATION';

export class PlayerMessage
{
  id: number;
  typeCd: string;
  functionCd: string;
  text: string;
  subject: string;
  objectId: number;
  objectName: string;
  seen: boolean;
  actionRequired: boolean;
  date: Date;
  link: string;

  public static init(data: PlayerMessage): void
  {

  }
}
